var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.addressIsValid)?_c('el-tooltip',{staticClass:"item",attrs:{"content":_vm.processStringifiedAddress(_vm.row.riskAddress),"placement":"right-end"}},[_c('div',[_vm._v(_vm._s(_vm.processName()))])]):_c('div',[_vm._v(_vm._s(_vm.processName()))])
}
var staticRenderFns = []

export { render, staticRenderFns }